import { Trans } from 'react-i18next'
import { useSelector } from 'react-redux'
import { LanguageUtils } from '@pbt/pbt-ui-components'

import Link from '~/components/common/link/Link'
import FeatureToggle from '~/constants/featureToggle'
import {
  getBusinessSoapWidgets,
  getRenamedBusinessSoapWidgets,
} from '~/store/reducers/businesses'
import { getFeatureToggle } from '~/store/reducers/constants'
import { convertToKebabCase } from '~/utils'

export interface MarketplaceDeactivatedLinkProps {
  id: string
  marketplaceId: string
}

const MarketplaceDeactivatedLink = ({
  id,
  marketplaceId,
}: MarketplaceDeactivatedLinkProps) => {
  const BusinessSoapWidgets = useSelector(getBusinessSoapWidgets)!
  const RenamedBusinessSoapWidgets = useSelector(getRenamedBusinessSoapWidgets)!

  const isDefaultSoapNotesTemplatesEnabled = useSelector(
    getFeatureToggle(FeatureToggle.SET_DEFAULT_SOAP_NOTE_TEMPLATES),
  )

  const marketplaceItemName = LanguageUtils.getConstantTranslatedName(
    id,
    isDefaultSoapNotesTemplatesEnabled
      ? RenamedBusinessSoapWidgets
      : BusinessSoapWidgets,
  )

  return (
    <Trans
      components={{
        linkComponent: (
          <Link
            id={`deactivated-${convertToKebabCase(marketplaceItemName)}-link`}
            to={`/admin/general/marketplace/${marketplaceId}`}
          />
        ),
      }}
      i18nKey="Admin:SOAP_CUSTOMIZATION.DEACTIVATED_MARKETPLACE"
      values={{ marketplaceItemName }}
    />
  )
}

export default MarketplaceDeactivatedLink
